import { ChangeDetectorRef, Component, Inject, Injector, OnInit, Optional } from '@angular/core';
import { NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { select, Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromBckpStore from '@apps/bckp/store';
import { InputComboboxComponent } from '../../input-combobox/input-combobox.component';

@Component({
    selector: 'aa-input-copies-residences',
    templateUrl: '../../input-combobox/input-combobox.component.html',
    styleUrls: [
        '../../input.component.scss',
        '../../input-combobox/input-combobox.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputCopiesResidencesComponent,
            multi: true,
        }],
    standalone: false
})
export class InputCopiesResidencesComponent extends InputComboboxComponent implements OnInit
{

    constructor (
        injector: Injector,
        cdRef: ChangeDetectorRef,
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        private store: Store<IAuroraState>
    )
    {
        super(injector, validators, asyncValidators, cdRef);

        this.items = this.store
            .pipe(
                select(fromBckpStore.getCopiesResidencesOptions)
            );
    }

    ngOnInit ()
    {
        this.store.dispatch(fromBckpStore.BckpOptionsStoreActions.BckpLoadCopiesResidencesRequested());
    }

}
